module.exports = __webpack_public_path__ + "static/media/logo-white.5a30ba82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-white.svg
// module id = 1069
// module chunks = 0